/* LUNERA Black Friday 2026 — Electric Motion V2.
   Display-only countdown & motion. No prices, discounts, trackers or carts are altered. */
(function () {
  'use strict';
  if (window.__luneraBFControllerV2) return;
  window.__luneraBFControllerV2 = true;
  const instances = new Map();
  const motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function pad(value) { return String(value).padStart(2, '0'); }
  function getPhase(now, start, end) {
    return now < start ? 'pre' : (now < end ? 'live' : 'ended');
  }
  function enhance(root, cleanup) {
    const toggle = root.querySelector('[data-bf-motion-toggle]');
    if (!toggle) return;
    let paused = !!(motionQuery && motionQuery.matches);
    const label = toggle.querySelector('[data-bf-motion-label]');
    if (motionQuery && motionQuery.matches) {
      // Respect OS reduced-motion preference: don't offer a toggle that cannot override it.
      toggle.hidden = true;
      root.classList.add('bf-motion-paused');
      root.querySelectorAll('[data-bf-reveal]').forEach(function (node) { node.classList.add('bf-in-view'); });
      return;
    }
    function reflect() {
      root.classList.toggle('bf-motion-paused', paused);
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.setAttribute('aria-label', paused ? 'Pornește animațiile' : 'Oprește animațiile');
      if (label) label.textContent = paused ? 'Mișcare oprită' : 'Animații';
      if (paused) {
        root.querySelectorAll('[data-bf-reveal]').forEach(function (node) { node.classList.add('bf-in-view'); });
      }
    }
    function click() { paused = !paused; reflect(); }
    toggle.addEventListener('click', click);
    cleanup.push(function () { toggle.removeEventListener('click', click); });
    reflect();

    if ('IntersectionObserver' in window && !window.Shopify?.designMode && !(motionQuery && motionQuery.matches)) {
      const targets = root.querySelectorAll('[data-bf-reveal]');
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('bf-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -25px 0px', threshold: 0.07 });
      targets.forEach(function (node) { observer.observe(node); });
      // Only after the observer is established: no invisible content when JS is off.
      root.classList.add('bf-motion-enabled');
      cleanup.push(function () {
        observer.disconnect();
        root.classList.remove('bf-motion-enabled');
      });
    }
  }

  function initialise(root) {
    if (instances.has(root)) return;
    const start = Date.parse(root.dataset.bfStart);
    const end = Date.parse(root.dataset.bfEnd);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
    const elements = root.querySelectorAll('[data-bf-only]');
    const countdown = {
      days: root.querySelector('[data-bf-days]'),
      hours: root.querySelector('[data-bf-hours]'),
      minutes: root.querySelector('[data-bf-minutes]'),
      seconds: root.querySelector('[data-bf-seconds]')
    };
    const cleanup = [];
    let previousPhase = null;
    function render() {
      const now = Date.now();
      let phase = getPhase(now, start, end);
      // Preview is available only in Shopify's theme editor.
      const preview = root.dataset.bfPreview;
      if (window.Shopify && window.Shopify.designMode && ['pre', 'live', 'ended'].includes(preview)) {
        phase = preview;
      }
      if (phase !== previousPhase) {
        root.dataset.bfPhase = phase;
        elements.forEach(function (element) {
          const allowed = (element.getAttribute('data-bf-only') || '').trim().split(/\s+/);
          element.hidden = !allowed.includes(phase);
        });
        previousPhase = phase;
      }
      if (phase === 'ended') return;
      const seconds = Math.max(0, Math.ceil(((phase === 'pre' ? start : end) - now) / 1000));
      const values = {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60
      };
      Object.keys(countdown).forEach(function (key) {
        if (countdown[key]) countdown[key].textContent = pad(values[key]);
      });
    }
    enhance(root, cleanup);
    render();
    const timer = window.setInterval(render, 1000);
    cleanup.push(function () { window.clearInterval(timer); });
    instances.set(root, cleanup);
  }
  function rootsInside(container) {
    const roots = [];
    if (container.matches && container.matches('[data-bf-root]')) roots.push(container);
    if (container.querySelectorAll) container.querySelectorAll('[data-bf-root]').forEach(function (r) { roots.push(r); });
    return roots;
  }
  function scan(container) { rootsInside(container).forEach(initialise); }
  function unload(container) {
    rootsInside(container).forEach(function (root) {
      const cleanup = instances.get(root);
      if (!cleanup) return;
      cleanup.forEach(function (fn) { fn(); });
      instances.delete(root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
})();
